
import { FC, useState } from 'react'
import { SelectBox } from 'devextreme-react';
import { useAuth } from '@/modules/auth/core/Auth';
import { userService } from '@/projects/admin/services/user-service';
import CustomStore from 'devextreme/data/custom_store';
import { t } from 'i18next';




const Impersonation: FC = () => {

    const { impersonate, removeImpersonate } = useAuth()
    

    const [impersonatableUserStore] = useState(new CustomStore({
        key: 'userName',
        load: userService.listImpersonatableUsers,
        byKey: async (key, loadOptions: any) => {
            var returnObject = null;
            if (key) {
                loadOptions.filter = ["UserName", "=", key];
                const objectsByID = (await userService.listImpersonatableUsers(loadOptions))
                returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
            }
            return returnObject
        },
        onLoading(loadOptions) {
            loadOptions.sort = [{"selector":"userName","desc":false}]   
    },
        useDefaultSearch: true
    }));

    const onSelectionChanged = async (e: any,) => {
        if (e.selectedItem) {
            document.body.classList.add("page-loading");
            const splashScreen = document.getElementById('splash-screen')
            if (splashScreen) {
                splashScreen.style.setProperty('display', 'flex')
            }
            await impersonate(e.selectedItem.userName);
        }
        else {
            await removeImpersonate();
        }
    }

    return (


        <div
            className='menu-item px-5'
            data-kt-menu-trigger='hover'
            data-kt-menu-placement='left-start'
            data-kt-menu-flip='bottom'
        >
            <span className='menu-link px-5'>

                <SelectBox
                    name='users'
                    showClearButton={true}
                    dataSource={impersonatableUserStore}
                    valueExpr="userName"
                    displayExpr="userName"
                    placeholder={t("switch_user")}
                    searchEnabled={true}
                    onSelectionChanged={onSelectionChanged}
                />
            </span>

        </div>

    )
}

export { Impersonation }
